import React, { useState } from 'react';
import {Modal, Image} from 'react-bootstrap';
import SalirIcon from '../../../Images/salir.svg';
import OtherFile from '../../../Images/kyc/other_files.svg';
import RfcOrCurp from '../../../Images/kyc/rfc_curp.svg';
import FSelfieId from '../../../Images/kyc/f_id_selfie.svg';
import FUtilityBill from '../../../Images/kyc/f_utility_bill.svg';
import Passport from '../../../Images/kyc/f_passport.svg';
import IdFront from '../../../Images/kyc/f_id_front.svg';
import '../index.css';

const HelpTool = ({show, handleClose, ...props}) => {
  const [passportOrID, setPassportOrID] = useState(1)
  const {help_tools} = props.traductions.kyc.form.moral;

  let imageTool = {
    f_id_selfie: FSelfieId,
    f_utility_bill: FUtilityBill,
    f_public_register: OtherFile,
    f_rfc_rep: RfcOrCurp,
    f_constitutive_act: OtherFile,
    f_last_constitutive_act: OtherFile,
    company_name: OtherFile,
    birthdate_company: OtherFile,
    country_incorporation: OtherFile,
    rfc_company: RfcOrCurp,
    curp: RfcOrCurp,
  }

  return (
    <Modal
      id="modal-help-tools"
      show={show}
      onHide={() => {handleClose(); setPassportOrID(1)}}
    >
      <Modal.Header  style={{display: 'flex', flexDirection: 'column', height: 45}} className='custom-header-settings'>
        <div style={{width: '100%', display: 'flex', justifyContent: 'flex-end'}}>
          <Image width={15} src={SalirIcon} onClick={() => handleClose()} alt="X" style={{cursor: 'pointer'}}/>
        </div>
      </Modal.Header>
      {
        props.typeHelp !== '' && props.typeHelp === 'company_name' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', fontFamily: 'DMSans-Medium'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.traductions.kyc.form.moral.Business_Name}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.bussines_name_description}
          </div>
        </div>
      }

      {
        props.typeHelp !== '' && props.typeHelp === 'birthdate_company' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.traductions.kyc.form.moral.Date_Incorporation}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.birthdate_company_description}
          </div>
        </div>
      }

      {
        props.typeHelp !== '' && props.typeHelp === 'country_incorporation' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.traductions.kyc.form.moral.country}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.country_incorporation_description}
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'rfc_company' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 24}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {props.rfcLabel !== '' ? props.rfcLabel : props.traductions.kyc.form.general.fiscalID}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 50}}>
            {help_tools.rfc_company_description}<br/>
            <span style={{color: '#959595', fontSize: 14}}>{help_tools.rfc_company_description_2}</span>
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'f_id_selfie' &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 15}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>{props.traductions.kyc.form.general.selfieID}</span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 15}}>
            {help_tools.selfie_id}<br/>
          </div>
          <div className='wrapper-blue' style={{textAlign: 'center'}}>
            <span style={{whiteSpace: 'pre-wrap'}}>{help_tools.selfie_id_description_2}</span>
          </div>
          <div className='wrapper-blue' style={{textAlign: 'center'}}>
            <span>{help_tools.selfie_id_description_3}</span>
          </div>
          <div className='wrapper-blue' style={{textAlign: 'center', marginBottom: 35}}>
            <span>{help_tools.selfie_id_description_4}</span>
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'f_constitutive_act'  &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: '15px 22px'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 15}}/>
          <div style={{textAlign: 'center', fontSize: 16, marginBottom: 20}}>
            <span style={{fontFamily: 'DMSans-Medium'}}>{props.traductions.kyc.form.general.Articles_Incorporation}</span>
          </div>
          <div className='wrapper-blue' style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 10, padding: '20px 40px', width: '100%'}}>
            {help_tools.f_constitutive_act_description_2}<br/>
          </div>
          <div className='wrapper-blue' style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 10, padding: '20px 40px', width: '100%'}}>
            {help_tools.f_constitutive_act_description}<br/>
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'curp'  &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', }}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 15}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>CURP</span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 45}}>
            {help_tools.curp_description}<br/>
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'id_number'  &&
        <div style={{display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center', padding: '15px 30px', height: 360}}>
          {
            passportOrID === 1 ? 
            <>
              <Image src={Passport} width={120} height={120} style={{marginBottom: 15, marginLeft: 30}}/>
              <div style={{textAlign: 'center', fontSize: 16}}>
              <span style={{fontFamily: 'DMSans-Medium'}}>
                {help_tools.passport_title}
              </span>  
              </div>
              <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 15}}>
                {help_tools.passport_description}<br/>
              </div>
            </>
            :
            <>
              <Image src={IdFront} width={120} height={120} style={{marginBottom: 15}}/>
              <div style={{textAlign: 'center', fontSize: 16}}>
              <span style={{fontFamily: 'DMSans-Medium'}}>
                {help_tools.id_title}
              </span>
              </div>
              <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 15}}>
                {help_tools.id_description}<br/>
              </div>
            </>
          }
          <div style={{display: 'flex', marginBottom:40}}>
            <div style={{marginRight: 3}} className={passportOrID === 1 ? 'circle-blue-active': 'circle-blue'} onClick={() => setPassportOrID(1)}/>
            <div className={passportOrID === 2 ? 'circle-blue-active': 'circle-blue'} onClick={() => setPassportOrID(2)}/>
          </div>
        </div>
      }
      {
        props.typeHelp !== '' && props.typeHelp === 'f_utility_bill'  &&
        <div style={{display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: '15px 30px'}}>
          <Image src={imageTool[props.typeHelp]} width={120} height={120} style={{marginBottom: 15}}/>
          <div style={{textAlign: 'center', fontSize: 16}}>
          <span style={{fontFamily: 'DMSans-Medium'}}>
            {help_tools.f_utility_bill_title}
          </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', textAlign: 'center', fontSize: 14, marginBottom: 45}}>
            {help_tools.f_utility_bill}<br/>
          </div>
        </div>
      }
    </Modal>
  )
}

export default HelpTool;